import { render, staticRenderFns } from "./ProfileImageModal.vue?vue&type=template&id=10c9ed76&scoped=true&"
import script from "./ProfileImageModal.vue?vue&type=script&lang=js&"
export * from "./ProfileImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileImageModal.vue?vue&type=style&index=0&id=10c9ed76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9ed76",
  null
  
)

export default component.exports